function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#343a6e",
    "data-original": "#343a6e"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    cx: 256,
    cy: 215.907,
    r: 215.907,
    fill: "#484b7f",
    "data-original": "#484b7f"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    cx: 213.88,
    cy: 154.875,
    r: 154.875,
    fill: "#ef487d",
    "data-original": "#ef487d"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M213.881,286.762c-72.723,0-131.887-59.164-131.887-131.887  C81.993,82.152,141.157,22.988,213.881,22.988c72.723,0,131.887,59.164,131.887,131.887  C345.767,227.598,286.603,286.762,213.881,286.762z",
    fill: "#ff668c",
    "data-original": "#ff668c"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M403.937,353.667v96.413c0,5.319-0.387,10.553-1.16,15.684C361.221,494.905,310.617,512,256,512  c-54.314,0-104.667-16.906-146.098-45.756c-1.223-8.537-1.849-17.178-1.849-25.882V334.158c0-8.046,3.26-15.329,8.537-20.605  c1.327-1.327,2.779-2.529,4.336-3.574c4.639-3.124,10.24-4.953,16.259-4.953c16.091,0,29.132,13.04,29.132,29.132V309.75  c0-8.046,3.26-15.318,8.537-20.595c5.277-5.277,12.56-8.537,20.605-8.537c16.081,0,29.132,13.051,29.132,29.132v-9.906  c0-8.046,3.26-15.329,8.526-20.605c5.277-5.266,12.56-8.526,20.605-8.526c16.091,0,29.132,13.04,29.132,29.132V174.153  c0-8.046,3.26-15.329,8.526-20.595c1.327-1.327,2.779-2.529,4.347-3.584c4.838-3.26,10.71-5.11,17.021-4.942  c15.893,0.408,28.369,13.876,28.369,29.78v204.946c0-15.663,5.736-29.978,15.214-40.981c1.024-1.191,2.079-2.33,3.187-3.438  l0.345-0.345C376.215,318.892,403.937,330.71,403.937,353.667z",
    fill: "#f9d5a9",
    "data-original": "#f9d5a9"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M295.729,149.973v210.286c0,3.555-2.882,6.437-6.437,6.437l0,0c-3.555,0-6.437-2.882-6.437-6.437   V174.152c0-8.046,3.26-15.329,8.526-20.595C292.709,152.23,294.162,151.029,295.729,149.973z",
    fill: "#e5a379",
    "data-original": "#e5a379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M237.466,275.664v96.423c0,3.555-2.882,6.437-6.437,6.437l0,0c-3.555,0-6.437-2.882-6.437-6.437   v-72.244c0-8.046,3.26-15.329,8.526-20.595C234.446,277.921,235.898,276.719,237.466,275.664z",
    fill: "#e5a379",
    "data-original": "#e5a379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M179.192,285.57v93.832c0,3.555-2.882,6.437-6.437,6.437l0,0c-3.555,0-6.437-2.882-6.437-6.437   v-69.653c0-8.046,3.26-15.329,8.526-20.595C176.172,287.827,177.624,286.625,179.192,285.57z",
    fill: "#e5a379",
    "data-original": "#e5a379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M120.926,309.979v163.527c-3.741-2.33-7.419-4.754-11.024-7.262   c-1.223-8.537-1.849-17.178-1.849-25.882V334.158c0-8.046,3.26-15.329,8.537-20.605   C117.917,312.226,119.369,311.024,120.926,309.979z",
    fill: "#e5a379",
    "data-original": "#e5a379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M356.333,338.776V441.97c0,4.202-3.405,7.607-7.607,7.607l0,0c-4.202,0-7.607-3.405-7.607-7.607   v-62.213C341.119,364.094,346.856,349.779,356.333,338.776z",
    fill: "#e5a379",
    "data-original": "#e5a379"
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M270.332,185.712l-30.837-30.838l30.837-30.837c2.963-2.963,2.963-7.769,0-10.732L255.45,98.423  c-2.963-2.963-7.769-2.963-10.732,0l-30.837,30.837l-30.838-30.838c-2.963-2.963-7.769-2.963-10.732,0l-14.881,14.881  c-2.963,2.963-2.963,7.769,0,10.732l30.838,30.838l-30.837,30.837c-2.963,2.963-2.963,7.769,0,10.732l14.881,14.881  c2.963,2.963,7.769,2.963,10.732,0l30.837-30.837l30.838,30.838c2.963,2.963,7.769,2.963,10.732,0l14.881-14.881  C273.295,193.482,273.295,188.676,270.332,185.712z",
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.4bb775f136761776360ba3887219f126.svg";
export { ForwardRef as ReactComponent };